import React, { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';

const BarcodeGenerator = ({ value, productName, options = {} }) => {
  const canvasRef = useRef(null);

  const defaultOptions = {
    format: "CODE128",
    width: 2,
    height: 60,
    displayValue: true,
    fontSize: 14,
    textMargin: 2,
    fontOptions: "bold",
    textAlign: "center",
    textPosition: "bottom",
    background: "#ffffff",
    lineColor: "#000000",
    margin: 10,
    marginTop: 10,
    marginBottom: 10,
    marginLeft: 10,
    marginRight: 10,
    ...options
  };

  useEffect(() => {
    if (canvasRef.current && value) {
      try {
        // Aplicar JSBarcode para generar el código
        JsBarcode(canvasRef.current, value, defaultOptions);
        
        // Después de generar el código, añadimos el nombre del producto al canvas
        if (productName) {
          const canvas = canvasRef.current;
          const ctx = canvas.getContext('2d');
          
          // Guardar el estado original del canvas
          const originalImageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          
          // Aumentar la altura del canvas para incluir el nombre del producto
          const originalHeight = canvas.height;
          canvas.height = originalHeight + 30; // Añadir espacio para el nombre
          
          // Limpiar el canvas y volver a dibujar el código de barras original
          ctx.fillStyle = '#ffffff';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          
          // Dibujar el nombre del producto en la parte superior
          ctx.fillStyle = '#000000';
          ctx.font = 'bold 14px Arial';
          ctx.textAlign = 'center';
          ctx.fillText(productName, canvas.width / 2, 20);
          
          // Dibujar la imagen original del código de barras debajo del nombre
          ctx.putImageData(originalImageData, 0, 30);
        }
      } catch (error) {
        console.error('Error generando código de barras:', error);
        // En caso de error, mostrar el valor como texto
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        canvas.width = 300;
        canvas.height = 80;
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = '#000000';
        ctx.font = '14px Arial';
        ctx.textAlign = 'center';
        ctx.fillText('Error generando código', canvas.width / 2, 30);
        ctx.fillText(value, canvas.width / 2, 50);
      }
    }
  }, [value, productName, options]);

  if (!value) {
    return (
      <div className="flex items-center justify-center h-20 bg-gray-100 rounded-lg border-2 border-dashed border-gray-300">
        <p className="text-gray-500 text-sm">Sin código para generar</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center">
      <canvas 
        ref={canvasRef}
        className="max-w-full h-auto"
        style={{ maxWidth: '100%' }}
      />
    </div>
  );
};

export default BarcodeGenerator;
